import React, { useCallback, useState } from "react";
import FormInputText from "../../../../components/FormInputText";
import * as Yup from "yup";
import { useFormik } from "formik";
import { useEffect } from "react";
import { getData, putEncodedData } from "../../../../services/httphandler";
import { toast } from "react-toastify";
import Loader from "../../../../components/loader";
function ManageShipping() {
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [data, setData] = useState(null);
  const getDetails = useCallback(async (load = true) => {
    if (load) {
      setLoading(true);
    }
    const data = await getData("setting/shipping/get");
    if (data && data?.response_code === 200) {
      console.log(data, "shippgin data");

      setData(data?.data);
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    getDetails();
  }, [getDetails]);

  const validationSchema = Yup.object().shape({
    label: Yup.string().required("*Title is Required"),
    shipping_price: Yup.number()
      .min(0, "Must be a valid number")
      .required("*From Date is Required"),
  });

  const { values, handleSubmit, touched, errors, handleChange } = useFormik({
    initialValues: {
      shipping_price: data?.shipping_price,
      label: data?.label || "",
      id: data?.id || "",
    },
    enableReinitialize: true,
    validationSchema,
    onSubmit: async ({ label, shipping_price, id }) => {
      setSubmitting(true);
      await putEncodedData("setting/shipping/update", {
        label,
        shipping_price,
        id,
      })
        .then((response) => {
          if (response?.response_code === 200) {
            toast.success(response?.message);
            getDetails(false);
          } else {
            toast.error(response?.message);
          }
        })
        .finally(() => {
          setSubmitting(false);
        });
    },
  });
  return (
    <article class="col-lg-9">
      <div class="article-body store-bd-gy">
        <div class="row align-items-center col-rever">
          <div class="col-sm-12 col-md-12 col-lg-12">
            <h2 class="head-title">Manage Shipping</h2>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 ">
            {loading ? (
              <div className="">
                <Loader />
              </div>
            ) : (
              <form onSubmit={handleSubmit} class="form-style">
                <div class="row">
                  <div className="col-sm-12">
                    <div class="input-container">
                      <FormInputText
                        placeholder="Enter COD Label"
                        type="text"
                        image="product.png"
                        onChange={handleChange}
                        name="label"
                        value={values.label}
                        title="Label"
                      />
                      <span className="errorMessage">
                        {touched["label"] && errors["label"]}
                      </span>
                    </div>
                  </div>
                  <div class="col-sm-12 col-md-12 col-lg-12">
                    <div class="input-container">
                      <FormInputText
                        placeholder="Enter Shipping Amount"
                        type="number"
                        image="product.png"
                        onChange={handleChange}
                        name="shipping_price"
                        value={values.shipping_price}
                        title="Shipping Price"
                      />
                    </div>

                    <span className="errorMessage">
                      {touched["shipping_price"] && errors["shipping_price"]}
                    </span>
                  </div>

                  <div class="col-sm-12 col-md-12 col-lg-12">
                    <div class="text-center">
                      <button class="btn btn-save" disabled={submitting}>
                        {submitting ? <Loader /> : "Save"}
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            )}
          </div>
        </div>
      </div>
    </article>
  );
}

export default ManageShipping;
